import { useState } from "react";

// Avatar with graceful fallback: shows the user's initials when there is
// no photo or the photo URL fails to load.
export default function UserAvatar({ src, name, size = 104, className = "" }) {
    const [failed, setFailed] = useState(false);

    const initials = (name || "")
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((w) => w.charAt(0))
        .join("")
        .toUpperCase() || "?";

    if (!src || failed) {
        return (
            <span
                className={`avatar-fallback ${className}`}
                style={{ width: size, height: size, fontSize: Math.round(size * 0.34) }}
                aria-label={name}
            >
                {initials}
            </span>
        );
    }

    return (
        <img
            src={src}
            alt={name}
            className={className}
            style={{ width: size, height: size, objectFit: "cover" }}
            onError={() => setFailed(true)}
        />
    );
}
